import { Award, Download } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { formatDate } from '@/lib/utils'
import { FormationMilestone } from '@/types'

type Props = {
  milestone: FormationMilestone
  legalName: string
  jurisdictionCode: string
}

// The certificate moment is the emotional peak of the product — a hero
// card, not one more row in the document vault. Only renders once the
// certificate file is actually attached and downloadable.
export function CertificateCard({ milestone, legalName, jurisdictionCode }: Props) {
  if (!milestone.certificate_url) return null

  return (
    <section aria-labelledby="certificate-heading" className="mb-8 rounded-lg border bg-primary/5 px-6 py-8 text-center">
      <Award className="w-8 h-8 text-primary mx-auto mb-3" aria-hidden="true" />
      <h2 id="certificate-heading" className="text-lg font-semibold text-foreground">
        {legalName} is officially formed
      </h2>
      <p className="text-sm text-muted-foreground mt-1">
        {jurisdictionCode} issued your certificate on {formatDate(milestone.at || '')}
        {milestone.certificate_number && ` — certificate #${milestone.certificate_number}`}
      </p>
      <Button asChild className="mt-4">
        <a href={milestone.certificate_url} target="_blank" rel="noopener noreferrer">
          <Download className="w-4 h-4 mr-1.5" aria-hidden="true" />
          Download your certificate
        </a>
      </Button>
    </section>
  )
}
